import { Protocol } from '../../Protocol';

export class UsersProtocol {
  public static readonly GET_ALL_USER: string = `${Protocol.YATUNG_API_ROOT}/users/pageable`; // 分頁搜尋所有使用者帳號
  public static readonly USER_URL: string = `${Protocol.YATUNG_API_ROOT}/users`; // 使用者帳號url
  public static readonly GET_USERS_ONLY_AIV: string = `${Protocol.YATUNG_API_ROOT}/users/onlyaiv`; // 取得所有AIV的使用者帳號
}
